export default class ParallaxAnimation {
    constructor(element, scrollContainer, progressFunction) {
        this.element = element;
        this.scrollContainer = scrollContainer;
        this.progressFunction = progressFunction;
        this.handleScroll = this.handleScroll.bind(this);
        this.applyParallax = this.applyParallax.bind(this);
        scrollContainer.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
        window.setTimeout(this.applyParallax, 500);
    }
    dispose() {
        this.scrollContainer.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
    }
    handleResize() {
        window.setTimeout(this.applyParallax, 500);
    }
    handleScroll() {
        this.applyParallax();
    }
    applyParallax() {
        const top = this.element.getBoundingClientRect().top + this.scrollContainer.scrollTop;
        const bottom = this.element.getBoundingClientRect().bottom + this.scrollContainer.scrollTop;
        const scrollTop = this.scrollContainer.scrollTop;
        const scrollHeight = this.scrollContainer.clientHeight;
        const total = scrollHeight + (bottom - top);
        const current = (scrollTop + scrollHeight - top);
        this.progressFunction(current / total, this.element);
    }
}
//# sourceMappingURL=ParallaxAnimation.js.map